// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/usage_event/v1/usage_event.proto" (package "c1.api.usage_event.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResource
 */
export interface UsageResource {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string display_name = 5;
     */
    displayName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_login = 6;
     */
    lastLogin?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 9;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: int64 principal_count = 10;
     */
    principalCount: number;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceState state = 11;
     */
    state?: UsageResourceState;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceDiscoveredBy discovered_by = 12;
     */
    discoveredBy?: UsageResourceDiscoveredBy;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceDiscoveredBy
 */
export interface UsageResourceDiscoveredBy {
    /**
     * @generated from protobuf oneof: discovered_by
     */
    discoveredBy: {
        oneofKind: "oauthToken";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceDiscoveredBy.Token oauth_token = 100;
         */
        oauthToken: UsageResourceDiscoveredBy_Token;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceDiscoveredBy.Token
 */
export interface UsageResourceDiscoveredBy_Token {
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceState
 */
export interface UsageResourceState {
    /**
     * @generated from protobuf oneof: state
     */
    state: {
        oneofKind: "discovered";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceState.UsageResourceDiscovered discovered = 100;
         */
        discovered: UsageResourceState_UsageResourceDiscovered;
    } | {
        oneofKind: "ignored";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceState.UsageResourceIgnored ignored = 101;
         */
        ignored: UsageResourceState_UsageResourceIgnored;
    } | {
        oneofKind: "managed";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceState.UsageResourceManaged managed = 102;
         */
        managed: UsageResourceState_UsageResourceManaged;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceIgnored
 */
export interface UsageResourceState_UsageResourceIgnored {
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceDiscovered
 */
export interface UsageResourceState_UsageResourceDiscovered {
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceManaged
 */
export interface UsageResourceState_UsageResourceManaged {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * ID of virtual connector we use to sync the resource to an app
     *
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsagePrincipal
 */
export interface UsagePrincipal {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string principal_resource_type_id = 5;
     */
    principalResourceTypeId: string;
    /**
     * @generated from protobuf field: string principal_resource_id = 6;
     */
    principalResourceId: string;
    /**
     * @generated from protobuf field: string display_name = 7;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string email = 8;
     */
    email: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_login = 9;
     */
    lastLogin?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 10;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 11;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 12;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalDiscoveredBy discovered_by = 13;
     */
    discoveredBy?: UsagePrincipalDiscoveredBy;
    /**
     * @generated from protobuf field: string identity_user_id = 14;
     */
    identityUserId: string;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsagePrincipalDiscoveredBy
 */
export interface UsagePrincipalDiscoveredBy {
    /**
     * @generated from protobuf oneof: discovered_by
     */
    discoveredBy: {
        oneofKind: "oauthToken";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalDiscoveredBy.Token oauth_token = 100;
         */
        oauthToken: UsagePrincipalDiscoveredBy_Token;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsagePrincipalDiscoveredBy.Token
 */
export interface UsagePrincipalDiscoveredBy_Token {
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UpdateUsageResourceRequest
 */
export interface UpdateUsageResourceRequest {
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResource usage_resource = 1;
     */
    usageResource?: UsageResource;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 3;
     */
    expandMask?: UsageResourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceView
 */
export interface UsageResourceView {
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResource usage_resource = 1;
     */
    usageResource?: UsageResource;
    /**
     * @generated from protobuf field: string connector_path = 2;
     */
    connectorPath: string;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceExpandMask
 */
export interface UsageResourceExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.GetUsageResourceRequest
 */
export interface GetUsageResourceRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 5;
     */
    expandMask?: UsageResourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.GetUsageResourceResponse
 */
export interface GetUsageResourceResponse {
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceView usage_resource = 1;
     */
    usageResource?: UsageResourceView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.SearchUsageResourceRequest
 */
export interface SearchUsageResourceRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_ignored = 4;
     */
    includeIgnored: boolean;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.ListUsageResourcesRequest
 */
export interface ListUsageResourcesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 4;
     */
    expandMask?: UsageResourceExpandMask;
}
/**
 * The ListUsageResourceResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.usage_event.v1.ListUsageResourcesResponse
 */
export interface ListUsageResourcesResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.usage_event.v1.UsageResourceView list = 1;
     */
    list: UsageResourceView[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.MutateUsageResourceStateRequest
 */
export interface MutateUsageResourceStateRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceState state = 5;
     */
    state?: UsageResourceState;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 6;
     */
    expandMask?: UsageResourceExpandMask;
    /**
     * @generated from protobuf field: repeated string owner_ids = 7;
     */
    ownerIds: string[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsagePrincipalView
 */
export interface UsagePrincipalView {
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipal usage_principal = 1;
     */
    usagePrincipal?: UsagePrincipal;
    /**
     * @generated from protobuf field: string user_path = 2;
     */
    userPath: string;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsagePrincipalExpandMask
 */
export interface UsagePrincipalExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.GetUsagePrincipalRequest
 */
export interface GetUsagePrincipalRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string principal_resource_type_id = 5;
     */
    principalResourceTypeId: string;
    /**
     * @generated from protobuf field: string principal_resource_id = 6;
     */
    principalResourceId: string;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask = 7;
     */
    expandMask?: UsagePrincipalExpandMask;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.GetUsagePrincipalResponse
 */
export interface GetUsagePrincipalResponse {
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalView usage_principal = 1;
     */
    usagePrincipal?: UsagePrincipalView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.ListUsagePrincipalsRequest
 */
export interface ListUsagePrincipalsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 4;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 5;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 6;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask = 7;
     */
    expandMask?: UsagePrincipalExpandMask;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.ListUsagePrincipalsResponse
 */
export interface ListUsagePrincipalsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.usage_event.v1.UsagePrincipalView list = 1;
     */
    list: UsagePrincipalView[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.SearchUsageResourcesRequest
 */
export interface SearchUsageResourcesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the usage resources with a fuzzy search on display name.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_ignored = 4;
     */
    includeIgnored: boolean;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 5;
     */
    expandMask?: UsageResourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.SearchUsageResourcesResponse
 */
export interface SearchUsageResourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.usage_event.v1.UsageResourceView list = 1;
     */
    list: UsageResourceView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.SearchUsagePrincipalsResponse
 */
export interface SearchUsagePrincipalsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.usage_event.v1.UsagePrincipalView list = 1;
     */
    list: UsagePrincipalView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceRef
 */
export interface UsageResourceRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4;
     */
    resourceId: string;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.SearchUsagePrincipalsRequest
 */
export interface SearchUsagePrincipalsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the usage principals with a fuzzy search on display name or email
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * Only return principals of UsageResources that matches the refs in the array.
     *
     * @generated from protobuf field: repeated c1.api.usage_event.v1.UsageResourceRef usage_resources = 4;
     */
    usageResources: UsageResourceRef[];
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask = 5;
     */
    expandMask?: UsagePrincipalExpandMask;
}
// @generated message type with reflection information, may provide speed optimized methods
class UsageResource$Type extends MessageType<UsageResource> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResource", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "last_login", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "principal_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "state", kind: "message", T: () => UsageResourceState, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "discovered_by", kind: "message", T: () => UsageResourceDiscoveredBy, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResource
 */
export const UsageResource = new UsageResource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceDiscoveredBy$Type extends MessageType<UsageResourceDiscoveredBy> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceDiscoveredBy", [
            { no: 100, name: "oauth_token", kind: "message", oneof: "discoveredBy", T: () => UsageResourceDiscoveredBy_Token }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceDiscoveredBy
 */
export const UsageResourceDiscoveredBy = new UsageResourceDiscoveredBy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceDiscoveredBy_Token$Type extends MessageType<UsageResourceDiscoveredBy_Token> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceDiscoveredBy.Token", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceDiscoveredBy.Token
 */
export const UsageResourceDiscoveredBy_Token = new UsageResourceDiscoveredBy_Token$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceState$Type extends MessageType<UsageResourceState> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceState", [
            { no: 100, name: "discovered", kind: "message", oneof: "state", T: () => UsageResourceState_UsageResourceDiscovered },
            { no: 101, name: "ignored", kind: "message", oneof: "state", T: () => UsageResourceState_UsageResourceIgnored },
            { no: 102, name: "managed", kind: "message", oneof: "state", T: () => UsageResourceState_UsageResourceManaged }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceState
 */
export const UsageResourceState = new UsageResourceState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceState_UsageResourceIgnored$Type extends MessageType<UsageResourceState_UsageResourceIgnored> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceState.UsageResourceIgnored", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceIgnored
 */
export const UsageResourceState_UsageResourceIgnored = new UsageResourceState_UsageResourceIgnored$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceState_UsageResourceDiscovered$Type extends MessageType<UsageResourceState_UsageResourceDiscovered> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceState.UsageResourceDiscovered", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceDiscovered
 */
export const UsageResourceState_UsageResourceDiscovered = new UsageResourceState_UsageResourceDiscovered$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceState_UsageResourceManaged$Type extends MessageType<UsageResourceState_UsageResourceManaged> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceState.UsageResourceManaged", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceManaged
 */
export const UsageResourceState_UsageResourceManaged = new UsageResourceState_UsageResourceManaged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsagePrincipal$Type extends MessageType<UsagePrincipal> {
    constructor() {
        super("c1.api.usage_event.v1.UsagePrincipal", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "principal_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "principal_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "last_login", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "discovered_by", kind: "message", T: () => UsagePrincipalDiscoveredBy, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 14, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsagePrincipal
 */
export const UsagePrincipal = new UsagePrincipal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsagePrincipalDiscoveredBy$Type extends MessageType<UsagePrincipalDiscoveredBy> {
    constructor() {
        super("c1.api.usage_event.v1.UsagePrincipalDiscoveredBy", [
            { no: 100, name: "oauth_token", kind: "message", oneof: "discoveredBy", T: () => UsagePrincipalDiscoveredBy_Token }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsagePrincipalDiscoveredBy
 */
export const UsagePrincipalDiscoveredBy = new UsagePrincipalDiscoveredBy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsagePrincipalDiscoveredBy_Token$Type extends MessageType<UsagePrincipalDiscoveredBy_Token> {
    constructor() {
        super("c1.api.usage_event.v1.UsagePrincipalDiscoveredBy.Token", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsagePrincipalDiscoveredBy.Token
 */
export const UsagePrincipalDiscoveredBy_Token = new UsagePrincipalDiscoveredBy_Token$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUsageResourceRequest$Type extends MessageType<UpdateUsageResourceRequest> {
    constructor() {
        super("c1.api.usage_event.v1.UpdateUsageResourceRequest", [
            { no: 1, name: "usage_resource", kind: "message", T: () => UsageResource },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => UsageResourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UpdateUsageResourceRequest
 */
export const UpdateUsageResourceRequest = new UpdateUsageResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceView$Type extends MessageType<UsageResourceView> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceView", [
            { no: 1, name: "usage_resource", kind: "message", T: () => UsageResource },
            { no: 2, name: "connector_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceView
 */
export const UsageResourceView = new UsageResourceView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceExpandMask$Type extends MessageType<UsageResourceExpandMask> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "connector_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceExpandMask
 */
export const UsageResourceExpandMask = new UsageResourceExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUsageResourceRequest$Type extends MessageType<GetUsageResourceRequest> {
    constructor() {
        super("c1.api.usage_event.v1.GetUsageResourceRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => UsageResourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.GetUsageResourceRequest
 */
export const GetUsageResourceRequest = new GetUsageResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUsageResourceResponse$Type extends MessageType<GetUsageResourceResponse> {
    constructor() {
        super("c1.api.usage_event.v1.GetUsageResourceResponse", [
            { no: 1, name: "usage_resource", kind: "message", T: () => UsageResourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.GetUsageResourceResponse
 */
export const GetUsageResourceResponse = new GetUsageResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsageResourceRequest$Type extends MessageType<SearchUsageResourceRequest> {
    constructor() {
        super("c1.api.usage_event.v1.SearchUsageResourceRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "include_ignored", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.SearchUsageResourceRequest
 */
export const SearchUsageResourceRequest = new SearchUsageResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUsageResourcesRequest$Type extends MessageType<ListUsageResourcesRequest> {
    constructor() {
        super("c1.api.usage_event.v1.ListUsageResourcesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => UsageResourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.ListUsageResourcesRequest
 */
export const ListUsageResourcesRequest = new ListUsageResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUsageResourcesResponse$Type extends MessageType<ListUsageResourcesResponse> {
    constructor() {
        super("c1.api.usage_event.v1.ListUsageResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsageResourceView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.ListUsageResourcesResponse
 */
export const ListUsageResourcesResponse = new ListUsageResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutateUsageResourceStateRequest$Type extends MessageType<MutateUsageResourceStateRequest> {
    constructor() {
        super("c1.api.usage_event.v1.MutateUsageResourceStateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 5, name: "state", kind: "message", T: () => UsageResourceState },
            { no: 6, name: "expand_mask", kind: "message", T: () => UsageResourceExpandMask },
            { no: 7, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.MutateUsageResourceStateRequest
 */
export const MutateUsageResourceStateRequest = new MutateUsageResourceStateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsagePrincipalView$Type extends MessageType<UsagePrincipalView> {
    constructor() {
        super("c1.api.usage_event.v1.UsagePrincipalView", [
            { no: 1, name: "usage_principal", kind: "message", T: () => UsagePrincipal },
            { no: 2, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsagePrincipalView
 */
export const UsagePrincipalView = new UsagePrincipalView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsagePrincipalExpandMask$Type extends MessageType<UsagePrincipalExpandMask> {
    constructor() {
        super("c1.api.usage_event.v1.UsagePrincipalExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "identity_user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsagePrincipalExpandMask
 */
export const UsagePrincipalExpandMask = new UsagePrincipalExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUsagePrincipalRequest$Type extends MessageType<GetUsagePrincipalRequest> {
    constructor() {
        super("c1.api.usage_event.v1.GetUsagePrincipalRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 5, name: "principal_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 6, name: "principal_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UsagePrincipalExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.GetUsagePrincipalRequest
 */
export const GetUsagePrincipalRequest = new GetUsagePrincipalRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUsagePrincipalResponse$Type extends MessageType<GetUsagePrincipalResponse> {
    constructor() {
        super("c1.api.usage_event.v1.GetUsagePrincipalResponse", [
            { no: 1, name: "usage_principal", kind: "message", T: () => UsagePrincipalView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.GetUsagePrincipalResponse
 */
export const GetUsagePrincipalResponse = new GetUsagePrincipalResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUsagePrincipalsRequest$Type extends MessageType<ListUsagePrincipalsRequest> {
    constructor() {
        super("c1.api.usage_event.v1.ListUsagePrincipalsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 6, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UsagePrincipalExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.ListUsagePrincipalsRequest
 */
export const ListUsagePrincipalsRequest = new ListUsagePrincipalsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUsagePrincipalsResponse$Type extends MessageType<ListUsagePrincipalsResponse> {
    constructor() {
        super("c1.api.usage_event.v1.ListUsagePrincipalsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsagePrincipalView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.ListUsagePrincipalsResponse
 */
export const ListUsagePrincipalsResponse = new ListUsagePrincipalsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsageResourcesRequest$Type extends MessageType<SearchUsageResourcesRequest> {
    constructor() {
        super("c1.api.usage_event.v1.SearchUsageResourcesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "include_ignored", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "expand_mask", kind: "message", T: () => UsageResourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.SearchUsageResourcesRequest
 */
export const SearchUsageResourcesRequest = new SearchUsageResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsageResourcesResponse$Type extends MessageType<SearchUsageResourcesResponse> {
    constructor() {
        super("c1.api.usage_event.v1.SearchUsageResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsageResourceView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.SearchUsageResourcesResponse
 */
export const SearchUsageResourcesResponse = new SearchUsageResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsagePrincipalsResponse$Type extends MessageType<SearchUsagePrincipalsResponse> {
    constructor() {
        super("c1.api.usage_event.v1.SearchUsagePrincipalsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsagePrincipalView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.SearchUsagePrincipalsResponse
 */
export const SearchUsagePrincipalsResponse = new SearchUsagePrincipalsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceRef$Type extends MessageType<UsageResourceRef> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceRef
 */
export const UsageResourceRef = new UsageResourceRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsagePrincipalsRequest$Type extends MessageType<SearchUsagePrincipalsRequest> {
    constructor() {
        super("c1.api.usage_event.v1.SearchUsagePrincipalsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "usage_resources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsageResourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => UsagePrincipalExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.SearchUsagePrincipalsRequest
 */
export const SearchUsagePrincipalsRequest = new SearchUsagePrincipalsRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.usage_event.v1.UsageResourceService
 */
export const UsageResourceService = new ServiceType("c1.api.usage_event.v1.UsageResourceService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetUsageResourceRequest, O: GetUsageResourceResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListUsageResourcesRequest, O: ListUsageResourcesResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UpdateUsageResourceRequest, O: GetUsageResourceResponse },
    { name: "MutateState", options: { "authz.method": { role: "EDITOR" } }, I: MutateUsageResourceStateRequest, O: GetUsageResourceResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.usage_event.v1.UsageResourceSearchService
 */
export const UsageResourceSearchService = new ServiceType("c1.api.usage_event.v1.UsageResourceSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchUsageResourcesRequest, O: SearchUsageResourcesResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.usage_event.v1.UsagePrincipalService
 */
export const UsagePrincipalService = new ServiceType("c1.api.usage_event.v1.UsagePrincipalService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetUsagePrincipalRequest, O: GetUsagePrincipalResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListUsagePrincipalsRequest, O: ListUsagePrincipalsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.usage_event.v1.UsagePrincipalSearchService
 */
export const UsagePrincipalSearchService = new ServiceType("c1.api.usage_event.v1.UsagePrincipalSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchUsagePrincipalsRequest, O: SearchUsagePrincipalsResponse }
]);
